import { BreakpointsOptions } from '@mui/material';
import createBreakpoints from '@mui/system/createTheme/createBreakpoints';

const breakpointsOptions: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 480,
    md: 768,
    lg: 1200,
    xl: 1920,
  },
};

const breakpoints = createBreakpoints(breakpointsOptions);

export default breakpoints;
